<div class="ab-list-item-inner flex w-100 activity-type--assessment">
  <span class="ab-list-item__icon">
    <i class="icon fal"
       [ngClass]="getIconClass(item?.payload?.before?.level || 0, item?.payload?.assessment?.level)">
    </i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span> changed
      <app-activity-target-link [target]="item.target">{{item?.target | fullName}}’s</app-activity-target-link>
       assessment from <span class="mini-assessment"
        [ngClass]="getColorClass(item?.payload?.before?.level || 0)">{{item?.payload?.before?.level || 0}}</span> to <span
        class="mini-assessment"
        [ngClass]="getColorClass(item?.payload?.assessment?.level)">{{item?.payload?.assessment?.level}}</span>
    </div>
  </div>
  <app-activity-event-timestamp [item]="item" class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
